import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['title', 'description', 'categories', 'videoDate', 'file', 'form', 'method', 'iframe', 'iframeContainer'];
  connect() {
  }


  async newVideo() {
    $("#video-upload-form").removeClass('edit').addClass('new');
    let select = document.getElementsByClassName('multi-select')[0];
    let control = select.tomselect;
    control.clear();
    this.fileTarget.src = $(this.fileTarget).attr('osrc')
    this.titleTarget.value = "";
    this.descriptionTarget.value = "";
    this.categoriesTarget.value = "";
    // this.dateTarget.value = "";
    this.videoDateTarget.value = "";
    this.formTarget.action = "/admin/videos";
    this.methodTarget.value = "post";
    this.iframeTarget.textContent = '';
    this.iframeContainerTarget.classList.add("d-none");
    console.log("newVideo");
    $('#addVideoModal .modal-title').addClass('d-none');
    $('#addVideoModal .modal-title.add-video').removeClass('d-none');
    $('.instructionsLabel').removeClass('d-none');
    $('#addVideoModal .input-dummy').css('width', '80px').addClass('mb-5');
    $('#addVideoModal #videoPicture').addClass('p-5');
    $('.publish-video-btn').text($('.publish-video-btn').data('view-text'));
    $('.without-publish-video-btn').text($('.without-publish-video-btn').data('view-text'));
    $('#plyr-player-video').addClass('d-none');
    $('.input-dummy').removeClass('d-none');
    $('#file-input').prop('disabled', false);
  }
  
  async fetchVideo(event) {
    $("#video-upload-form").removeClass('new').addClass('edit');
    const id = event.currentTarget.dataset.id;
    const response = await fetch('/admin/videos/' + id + ".json");
    const data = await response.json();
    this.fileTarget.src = data.video.image_url;
    this.titleTarget.value = data.video.title;
    this.descriptionTarget.value = data.video.description;
    this.categoriesTarget.value = data.video.categories_text;
    this.videoDateTarget.value = data.video.video_date;
    this.formTarget.action = '/admin/videos/' + id;
    this.iframeTarget.textContent = '<iframe src="' + this.iframeTarget.dataset.api_url + 'videos/' + id + '/embed">';
    this.iframeContainerTarget.classList.remove("d-none");
    this.methodTarget.value = "patch";
    let select = document.getElementsByClassName('multi-select')[0];
    let control = select.tomselect;
    control.clear();
    data.video.categories_text.split(",").forEach(function (item) {
      control.addItem(item);
    });
    $('#addVideoModal .modal-title').addClass('d-none');
    $('#addVideoModal .modal-title.edit-video').removeClass('d-none');
    $('#addVideoModal #videoPicture').removeClass('p-5');
    $('#addVideoModal .input-dummy').css('width', '100%').removeClass('mb-5');
    $('.instructionsLabel').addClass('d-none');
    if(data.video.published_at) {
      $('.publish-video-btn').text($('.publish-video-btn').data('edit-text'));
      $('.without-publish-video-btn').text($('.without-publish-video-btn').data('edit-text-unpub'));
    }
    else
    {
      $('.publish-video-btn').text($('.publish-video-btn').data('edit-text-pub'));
      $('.without-publish-video-btn').text($('.without-publish-video-btn').data('edit-text'));
    }
    $('.input-dummy').addClass('d-none');
    $('#file-input').prop('disabled', true);
    $('#plyr-player-video').removeClass('d-none');
    console.log(data.video.file_url);
    $('#plyr-player-video').attr("src", data.video.file_url);
    $('#plyr-player-video').attr("poster", data.video.image_url);
  }
  async fetchCategories() {
    console.log("fetchCategories");
  }
}